import { createFileRoute } from "@tanstack/react-router";
import AdminCustomerPortal from "@/pages/admin/AdminCustomerPortal";

export const Route = createFileRoute("/_adminLayout/admin/customer-portal")({
  component: AdminCustomerPortal,
});
